import type {
  InterstateLookupTokens,
  MuiSxProps
} from "@dealer-center/core-components";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  MuiCollapse,
  MuiList,
  MuiListItemButton,
  MuiListItemText,
  MuiListSubheader
} from "@dealer-center/core-components";
import type { NavigationMenuItemInterface } from "@dealer-center/ddc-api-commoncontainer-interface";
import {
  isNavigationMenuItemInterfaceHeader,
  isNavigationMenuItemInterfaceNavigate,
  isNavigationMenuItemInterfaceParent
} from "@dealer-center/ddc-api-commoncontainer-interface";

export interface coloorNamesInterface {
  background: InterstateLookupTokens;
  color: InterstateLookupTokens;
  hover: InterstateLookupTokens;
}
export const colorNames: coloorNamesInterface = {
  background: "sem.color.surface.light",
  color: "sem.color.surface.button.primary.rest",
  hover: "sem.color.surface.interactive.selected"
};

const defaultDepth = 1;
const muiCollapseSx = {
  borderBottom: "1px solid #e3e3e3"
};
export const buildNavMenuRoot = (
  handleExpandClick: (index?: string) => void,
  expandedIndexs: string[],
  onClick: (params: { link: NavigationMenuItemInterface }) => void,
  navbarItems: NavigationMenuItemInterface[],
  colorNames: coloorNamesInterface
): React.ReactElement[] => {
  const buildNavMenu = (
    items?: NavigationMenuItemInterface[],
    depth = defaultDepth
  ): React.ReactElement[] | undefined => {
    const sx: MuiSxProps = {
      "&:hover": {
        bgcolor: colorNames.hover
      },
      pl: depth * 2
    };
    return items?.map(item => {
      if (isNavigationMenuItemInterfaceParent(item)) {
        const children = buildNavMenu(item.links, depth + 1);
        return (
          <>
            <MuiListItemButton
              key={`${item.label}_parent`}
              sx={sx}
              onClick={() => handleExpandClick(item.label)}
            >
              <MuiListItemText primary={item.label} />
              {expandedIndexs.includes(item.label) ? (
                <ChevronUpIcon title="Expand" />
              ) : (
                <ChevronDownIcon title="Collapse" />
              )}
            </MuiListItemButton>

            <MuiCollapse
              unmountOnExit
              in={expandedIndexs.includes(item.label) ? true : false}
              sx={muiCollapseSx}
              timeout="auto"
            >
              <MuiList dense disablePadding component="div">
                {children}
              </MuiList>
            </MuiCollapse>
          </>
        );
      }
      if (isNavigationMenuItemInterfaceHeader(item)) {
        return (
          <MuiListSubheader key={`${item.label}_header`} sx={{ pl: depth * 2 }}>
            {item.label}
          </MuiListSubheader>
        );
      }
      if (isNavigationMenuItemInterfaceNavigate(item)) {
        return (
          <MuiListItemButton
            key={`${item.label}_navigate`}
            sx={sx}
            onClick={() => internalOnClick(item)}
          >
            <MuiListItemText primary={item.label} />
          </MuiListItemButton>
        );
      }
      return <></>;
    });
  };
  const internalOnClick = (item: NavigationMenuItemInterface) => {
    onClick({ link: item });
  };

  return buildNavMenu(navbarItems) || [];
};
